"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toasterIcon = void 0;

var _stylitas = require("@creditas/stylitas");

const toasterIcon = ({
  theme
}) => (0, _stylitas.css)`
  border-right: 1px solid ${theme.bColorneutral03};
  min-height: 64px;
  padding: 8px 7.5px 8px 7px;
`;

exports.toasterIcon = toasterIcon;